/**
 * Newsletter sign-up, answered in place.
 *
 * The form posts to /contact#contact_form, so a sign-up reloaded the whole page
 * and then jumped to the anchor, dropping the reader at the foot of the footer
 * to read a confirmation. The address still goes to Shopify by the same POST to
 * the same endpoint; only the navigation is replaced, and the confirmation is
 * written where the field already is.
 *
 * Progressive enhancement: with this script absent or a request that fails, the
 * form submits normally and the page behaves exactly as it did before.
 */
(() => {
  'use strict';

  const FORM = 'form.email-signup__form';
  const he = document.documentElement.lang.startsWith('he');

  /** Reads Shopify's own reply rather than assuming it worked. */
  function readResult(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const success = doc.querySelector('[id^="Email-signup__message-success"]');
    if (success) return { ok: true, text: success.textContent.trim() };
    const error = doc.querySelector('[id^="Email-signup__message-error"]');
    if (error) return { ok: false, text: error.textContent.trim() };
    return null;
  }

  function message(form, text, ok) {
    let note = form.querySelector('.email-signup__message[data-tn-note]');
    if (!note) {
      note = document.createElement('div');
      note.className = 'email-signup__message';
      note.dataset.tnNote = '';
      note.setAttribute('role', 'status');
      note.setAttribute('aria-live', 'polite');
      form.appendChild(note);
    }
    note.dataset.tnState = ok ? 'ok' : 'error';
    note.textContent = text;
  }

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest(FORM);
    if (!form) return;
    if (form.dataset.tnBusy === 'true') { event.preventDefault(); return; }

    const input = form.querySelector('input[type="email"]');
    if (input && !form.reportValidity()) return;

    event.preventDefault();
    form.dataset.tnBusy = 'true';

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'text/html' },
      });
      const result = readResult(await response.text());
      if (!result) throw new Error('Unrecognised response');

      message(form, result.text, result.ok);
      if (result.ok && input) input.value = '';
    } catch {
      /* Anything unexpected hands the sign-up back to the browser, which is the
         behaviour this script replaced and is known to work. */
      form.dataset.tnBusy = 'false';
      form.removeAttribute('data-tn-enhanced');
      form.submit();
      return;
    }

    form.dataset.tnBusy = 'false';
  });
})();
